// extracted by mini-css-extract-plugin
module.exports = {"field":"NameEdit_field__3-ArX","fieldWrapper":"NameEdit_fieldWrapper__1TqQ1","submitButton":"NameEdit_submitButton__3WorR"};